// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { getBundleAuditEvents } from '@/bundle/api/get-bundle-audit-events';
import { bundleQueryKey } from '@/bundle/hooks/use-bundles';
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { Stack, Typography } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/catalog/bundles/$bundleKey/audit')({
  component: BundleAuditRoute,
});

/**
 * Bundle audit page component.
 * Lists this bundle's create, update, archive, and unarchive events.
 */
function BundleAuditRoute() {
  const { bundleKey } = Route.useParams();
  return <BundleAuditContent bundleKey={bundleKey} />;
}

function BundleAuditContent(props: { bundleKey: string }) {
  const { data: auditEvents } = useSuspenseQuery({
    queryKey: [...bundleQueryKey(props.bundleKey), 'audit'],
    queryFn: () => getBundleAuditEvents(props.bundleKey),
  });

  return (
    <HardfinTabCardWrapper title="Audit log">
      <Stack spacing={2} paddingTop={2}>
        {auditEvents.length === 0 ? (
          <Typography color="text.secondary" textAlign="center">
            No audit events for this bundle
          </Typography>
        ) : (
          auditEvents.map((event) => (
            <AuditEventListItem key={event.id} event={event} />
          ))
        )}
      </Stack>
    </HardfinTabCardWrapper>
  );
}
